export default function AboutHero() {
  return (
    <section className="pt-48 pb-32 px-8">
      <div className="max-w-5xl mx-auto text-center">
        <h1 className="text-7xl md:text-8xl font-light text-[#0E1A2B] mb-6 leading-[1.05] tracking-tight">
          Operational Intelligence, Implemented.
        </h1>
        <p className="text-2xl font-light text-[#5C6675] leading-relaxed max-w-3xl mx-auto mt-8">
          We help organizations move beyond experimentation with AI by implementing structured systems that improve performance and accountability.
        </p>
      </div>
    </section>
  );
}